import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { ProviderContract } from "@customTypes/providerContract";

import { providerContractQKeys } from "./queryKeys";


interface QueryProps {
  providerId: string;
  isEnabled?: boolean;
}

const select = (res: any): ProviderContract | null => {
  // The API returns an array, we need to find the contract for this provider
  // Based on the API docs, we filter by provider query param to get the specific contract
  if (res.data && Array.isArray(res.data) && res.data.length > 0) {
    const contract = res.data[0]; // First contract for this provider
    return {
      _id: contract._id,
      provider: contract.provider,
      provider_type: contract.provider_type,
      services: contract.services || [],
      start_date: contract.start_date,
      end_date: contract.end_date,
      commission_split: {
        provider_percentage: contract.commission_split.provider_percentage,
        laruche_percentage: contract.commission_split.laruche_percentage,
      },
      service_overrides: contract.service_overrides || {},
      category_overrides: contract.category_overrides || {},
      tier_rules: contract.tier_rules || null,
      custom_conditions: contract.custom_conditions || null,
      profile_id: contract.profile_id || null,
      signed_contract_url: contract.signed_contract_url || null,
      created_at: contract.created_at,
      updated_at: contract.updated_at,
    };  }

  return null;
};

export const useGetContractByProvider = ({
  providerId,
  isEnabled = true,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: providerContractQKeys.byProvider(providerId),
    queryFn: () => {
      return api.get("clinic/provider-contracts", {
        params: {
          provider: providerId,
        },
      });
    },
    select,
    enabled: isEnabled && !!providerId,
    staleTime: 1000 * 60 * 5, // 5 minutes

    onError: (res: any) => {
      console.error("[From Get Contract By Provider]", res);
      handleErrors(res, "query");
    },
  });
};
